import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { of } from 'rxjs';
import { NgZone } from '@angular/core';
import { LoggerService } from '../services/logger.service';

export const onboardingGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const ngZone = inject(NgZone);
  const logger = inject(LoggerService);

  const log = (message: string, data?: any) => {
    ngZone.run(() => {
      const timestamp = new Date().toISOString();
      const logMessage = `[OnboardingGuard] ${timestamp} - ${message}`;
      if (data) {
        logger.warn(logMessage, data);
      } else {
        logger.warn(logMessage);
      }
    });
  };

  // Check if onboarding is completed (authGuard runs first to ensure authentication)
  const isProfileCompleted = authService.isProfileCompleted();
  log('Profile completion check', { isProfileCompleted });

  if (!isProfileCompleted) {
    const currentUrl = router.url;
    log('Onboarding not completed, redirecting to onboarding', { attemptedUrl: currentUrl });
    router.navigate(['/onboarding']);
    return of(false);
  }

  log('Onboarding completed, access granted');
  return of(true);
};
